import { AnalyticIdentifier } from '@common/neo.tax';
import { BaseTab, BaseTabs, SideDrawer, SideDrawerHeader, Stack, useTabState } from '@ui-components/neo.tax';
import React, { useState } from 'react';

import { useAnalyticId } from '@neo.tax/shared/state';
import { OrganizationMembersTableItem } from '@neo.tax/shared/types';
import { isInvitation } from '@neo.tax/shared/utils';

import { MemberInformation } from '../member-information';
import { MemberScopePane } from '../member-scope-pane';
import { StyledBaseTabPanel, StyledTabPanelContainer } from './organization-member-drawer.styled';

type OrganizationMemberDrawerProps = {
  isOpen: boolean;
  member?: OrganizationMembersTableItem;
  organizationId: string;
  setIsOpen: (isOpen: boolean) => void;
  setMemberId: (id: string | undefined) => void;
};

export const OrganizationMemberDrawer = ({
  isOpen,
  member,
  organizationId,
  setIsOpen,
  setMemberId,
}: OrganizationMemberDrawerProps): React.ReactElement => {
  const informationTab = useAnalyticId(AnalyticIdentifier.COMPANY_MEMBER_INFORMATION_TAB);
  const scopeTab = useAnalyticId(AnalyticIdentifier.COMPANY_MEMBER_SCOPE_TAB);

  const [selectedTab, setSelectedTab] = useState<string | null | undefined>(informationTab);
  const tabState = useTabState({ selectedId: selectedTab, setSelectedId: setSelectedTab });

  return (
    <SideDrawer
      header={
        member && (
          <SideDrawerHeader
            setIsOpen={(): void => setIsOpen(false)}
            subtitle={isInvitation(member) ? '' : member.email}
            title={isInvitation(member) ? member.email : member.fullName}
            withAvatar
          />
        )
      }
      isOpen={isOpen}
      afterClose={(): void => {
        setSelectedTab(informationTab);
        setMemberId(undefined);
      }}
      setIsOpen={setIsOpen}
    >
      {member && (
        <Stack direction="column" fullHeight>
          <BaseTabs state={tabState} fullWidth>
            <BaseTab label="Member Info" tabId={informationTab} />
            {isInvitation(member) ? <></> : <BaseTab label="Access" tabId={scopeTab} />}
          </BaseTabs>
          <StyledTabPanelContainer>
            <StyledBaseTabPanel state={tabState} tabId={informationTab}>
              <MemberInformation member={member} organizationId={organizationId} close={(): void => setIsOpen(false)} />
            </StyledBaseTabPanel>
            {isInvitation(member) ? (
              <></>
            ) : (
              <StyledBaseTabPanel state={tabState} tabId={scopeTab}>
                <MemberScopePane member={member} organizationId={organizationId} />
              </StyledBaseTabPanel>
            )}
          </StyledTabPanelContainer>
        </Stack>
      )}
    </SideDrawer>
  );
};
